import React, { useState } from 'react';
import { Dialog, Select, T } from '@colonist/ui';
import styles from './ChangeLanguageDialog.module.scss';
/** Dialog for choosing the site language. */ export const ChangeLanguageDialog = ({ open, languages, currentLanguage, onClose, onConfirm })=>{
    const [selectedLanguage, setSelectedLanguage] = useState(currentLanguage);
    const handleConfirm = ()=>onConfirm(selectedLanguage);
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        size: "sm"
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.footer.changeLanguagePopupTitle'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.content
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.footer.changeLanguagePopupBody'
        }
    }), /*#__PURE__*/ React.createElement(Select, {
        value: selectedLanguage,
        onSelect: setSelectedLanguage
    }, languages.map((language)=>/*#__PURE__*/ React.createElement("option", {
            key: language.code,
            value: language.code
        }, language.label))))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: handleConfirm
    })));
};
